module.exports = __webpack_public_path__ + "img/race-donator.56aa6f77.png";